<div class="input-container">
  <div  *ngIf="label" class="label-wrapper">
    <label [class.input-label]="labelOnPress" (click)="labelOnPress && labelOnPress()">
      {{ label }}
      <span *ngIf="required" class="required-star">*</span>
    </label>
  </div>

  <div [ngClass]="wrapperClasses" (click)="onPress && onPress()">
    <i *ngIf="leftIcon" [class]="leftIcon + ' left-icon'"></i>
    <div class="text-input-wrapper" [class.with-value-label]="valueLabel">
      <ng-content></ng-content>
    </div>
    <span *ngIf="valueLabel" class="value-label">{{ valueLabel }}</span>
    <i *ngIf="rightIcon" [class]="rightIcon + ' right-icon'"></i>
  </div>

  <div *ngIf="translatedErrorMessage">
    <app-error-message [message]="translatedErrorMessage"></app-error-message>
  </div>
</div>
